import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import { isEqual } from 'lodash';
import React from 'react';
import ChartLoader from '../../Loaders/ChartLoader';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/drag-panes')(Highcharts);
const hcnd = require('highcharts/modules/no-data-to-display');

hcnd(Highcharts);

const CustomHighChart = ({ options, isLoading }) => {
  if (isLoading) {
    return <ChartLoader height="150" width="600" />;
  }
  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType={'chart'}
      options={options}
    />
  );
};

export default React.memo(
  CustomHighChart,
  (prev, next) =>
    isEqual(prev.isLoading === next.isLoading) &&
    isEqual(prev.options === next.options)
);
